import React, { useState } from 'react'
import GloblePopup from '../../common/GloblePopup'
import { useTranslation } from 'react-i18next';

export default function BetDetailsPopup({isOpen,handleClose,betsData}) {
    const { t, i18n } = useTranslation();
    const [selectedFilter, setSelectedFilter] = useState("ALL");

    const filteredData = betsData.filter((item) => {
        if (selectedFilter === "ALL") {
          return true;
        } else if (selectedFilter === "BACK" || selectedFilter === "LAY") {
          return item.bettype2 === selectedFilter;
        } else if (selectedFilter === "DELETED") {
          return item.status === "CANCEL";
        }
        return true;
      });


    const formatDatefromAPI = (isoDate) => {
        const date = new Date(isoDate);

        // Get date components
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
        const year = date.getUTCFullYear();

        // Get time components in UTC+05:30 (Indian Standard Time)
        const options = { timeZone: "Asia/Kolkata", hour12: false };
        const timeString = date.toLocaleTimeString("en-GB", options); // 24-hour format HH:mm:ss

        // Get the UTC offset (+05:30)
        const offset = date.getTimezoneOffset(); // Returns offset in minutes
        const offsetHours = String(Math.abs(offset) / 60).padStart(2, "0");
        const offsetMinutes = String(Math.abs(offset) % 60).padStart(2, "0");
        const offsetSign = offset > 0 ? "-" : "+";

        return `${day}/${month}/${year} ${timeString} (UTC${offsetSign}${offsetHours}:${offsetMinutes})`;
    };
    
    let datas = filteredData.reduce((acc, item) => acc + (item.returns || 0), 0);

  return (
    <GloblePopup
      isOpen={isOpen}
      onClose={handleClose}
      title={t("Result")}
      className="betsresult-modal"
      cancelText="Close"
    >
        {betsData.length > 0 ? <div className="result-match-name"> { betsData[0]?.betType} -&gt; {betsData[0]?.event} {betsData[0]?.match? <>-&gt;</>:''} {betsData[0]?.match}  {betsData[0]?.marketName? <>-&gt;</>:''} {betsData[0]?.marketName} </div>:''}
        <div className="result-winner">
            <div className="row">
                <div className="col-6">{t('Winner')}:  {betsData[0]?.result}</div>
                <div className="col-6 text-right"> {t('Game Time')}: <span>{formatDatefromAPI(betsData[0]?.eventDate ?betsData[0].eventDate :betsData[0]?.date)}</span></div>
            </div>
        </div>
            <div className="result-filter">
                <div className="result-control-group">
                <div className="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="soda-all" name="example" value="all" checked={selectedFilter === "ALL"} onChange={() => (setSelectedFilter("ALL"))} className="custom-control-input"/>
                    <label htmlFor="soda-all" className="custom-control-label">All</label>
                </div>
                <div className="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="soda-back" name="example" checked={selectedFilter === "BACK"} onChange={() => (setSelectedFilter("BACK"))} className="custom-control-input"/>
                    <label htmlFor="soda-back" className="custom-control-label">Back</label>
                </div>
                <div className="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="soda-lay" name="example" checked={selectedFilter === "LAY"} onChange={() => (setSelectedFilter("LAY"))} className="custom-control-input"/>
                    <label htmlFor="soda-lay" className="custom-control-label">Lay</label>
                </div>
                <div className="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="soda-deleted" name="example" checked={selectedFilter === "DELETED"} onChange={() => (setSelectedFilter("DELETED"))} className="custom-control-input"/>
                    <label htmlFor="soda-deleted" className="custom-control-label">Deleted</label>
                </div>
                </div>
                <div className="result-total">
                    <div className='total-bets'>{t('Total Bets')}: <span className="green-txt">{filteredData.length}</span></div>
                    <div className='total-win'>{t('Total Win')}: <span className={`${datas > 0 ? 'green-txt' :'red-txt'}`}>{datas}</span></div>
                </div>
            </div>
            <div className="table-responsive report-table-modal mt-10 report-table">
                <table className="table">
                    <thead>
                        <tr>
                            <th className="bet-nation"><div>{t('Nation/Event')}</div></th>
                            <th className="text-right bet-user-rate"><div>{t("Rate")}</div></th>
                            <th className="text-right bet-amount"><div>{t('Amount')}</div></th>
                            <th className="text-right bet-amount"><div>{t('Win')}</div></th>
                            <th className="bet-date"><div>{t('Date')}</div></th>
                            <th className="bet-ip"><div>{t('Ip Address')}</div></th>
                        </tr>
                    </thead>
                    <tbody>
                    {filteredData.length > 0 ? (
                        filteredData.map((item, index) => (
                        <tr id={index} key={index} className={`${item?.bettype2 === 'BACK' ? 'back' : 'lay'}-border`}>
                            <td className="bet-nation">
                                <div>
                                    <div className="d-inline-block vm custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" value="0" id="__BVID__11673"/>
                                        <label className="custom-control-label" htmlFor="__BVID__11673"></label>
                                    </div>
                                    <span className="d-inline">{item.selectionName?item.selectionName:item.event}</span>
                                </div>
                            </td>
                            <td className="text-right bet-user-rate"><div>{item?.oddValue ? item?.oddValue :'-'}</div></td>
                            <td className="text-right bet-amount"><div>{item?.Stake ? item.Stake :'-'}</div></td>
                            <td className="text-right bet-amount"><div>{item?.returns ?item.returns :'-'}</div></td>
                            <td className="bet-date"><div>{formatDatefromAPI(item.date)}</div></td>
                            <td className="bet-ip"><div>{item?.ip ? item.ip :'-'}</div></td>
                        </tr>
                    ))
                    ) : (
                    <tr>
                        <td colSpan="6">{t('No results found')}</td>
                    </tr>
                    )}
                    </tbody>
                </table>
            </div>
    </GloblePopup>
  )
}
